import { Dialog } from 'primereact/dialog';
import React from 'react'
import { usePriorities } from '../../../Hooks/Features/TaskLayout/Priorities/usePriorities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { renderField } from '../../../utils/Helper';
import { ColorPicker } from 'primereact/colorpicker';
import CommonGrid from '../../../components/CommonCompo/CommonGrid/CommonGrid';
import CommanDialog from '../../../components/CommonCompo/CommanDialog/CommanDialog';

const Priorities = () => {
    const { formJson, visible, setVisible, handleChange, loader, fieldValues, upsertPriorities, columns, rowData, setFieldValues, getScreenSummary } = usePriorities();
    
    return (
        <div>
            <div className=" sk-header-row d-flex align-items-center justify-content-end">
                <div className="d-flex gap-2">
                    <button
                        type="button"
                        className="sk-btn sk-btn-primary"
                        onClick={getScreenSummary}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                    </button>
                    <button
                        type="button"
                        className="sk-btn text-white bg-black sk-btn-primary"
                        onClick={() => { setVisible({ show: true }); }}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-plus" /> Priority
                    </button>
                </div>
            </div>
            <CommonGrid columns={columns} data={[{ id: "all", title: "", children: rowData }]} expandAll={true} headerHeight={50} strippedTable={true} loader={loader?.grid} />
            <Dialog
                draggable={false}
                header="Create Field configuration"
                visible={visible?.show}
                onHide={() => { setVisible({ show: false }); setFieldValues({ color: "#ffffff" }) }}
                className='modal-xsmall'>
                <div>
                    <div className='row'>
                        {
                            formJson?.map((item, index) => (
                                renderField(item, index, (e) => { handleChange(item, e) }, fieldValues, {}, {
                                    is_edit: item?.textField, fromProject: 0
                                }, () => { }, () => { })
                            ))
                        }
                        <div className='d-flex gap-2 align-items-center'>
                            <p>Select Color</p>
                            <ColorPicker
                                format="hex"
                                value={fieldValues?.color || "0000"}
                                onChange={(e) => {
                                    handleChange({ name: "status_color" }, e);
                                }}
                            />
                        </div>
                    </div>
                    <div className='d-flex gap-2 align-items-center justify-content-end'>
                        <button className='sk-btn sk-btn-primary' onClick={() => { setVisible({ show: false }); setFieldValues({ color: "#ffffff" }) }}>Cancel</button>
                        {
                            loader?.btn ? <button className="sk-btn text-white bg-black sk-btn-primary" style={{ width: "65px", height: "30px" }}>
                                <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                                    <span className="sr-only"></span>
                                </div>
                            </button> : <button className='sk-btn text-white bg-black sk-btn-primary' onClick={() => upsertPriorities(false)} >Submit</button>
                        }
                    </div>
                </div>
            </Dialog>
            <CommanDialog
                visible={visible?.delete}
                message={"Are You Sure You Want to delete it?"}
                handleClose={() => { setVisible((prev) => ({ ...prev, delete: false })) }}
                handleFun={() => {
                    upsertPriorities(true)
                }}
                loader={loader?.btn}
            />
        </div>
    )
}

export default Priorities
